const PATH = 'fe.components.organization.edit_hierarchy.editable_node';

const messages = {
  save: {
    key: `${PATH}.save`,
    defaultValue: 'Save'
  },
  cancel: {
    key: `${PATH}.cancel`,
    defaultValue: 'Cancel'
  },
  editName: {
    key: `${PATH}.edit_name`,
    defaultValue: 'Edit Name'
  },
  classroom: {
    key: `${PATH}.classroom`,
    defaultValue: 'Classroom'
  },
  center: {
    key: `${PATH}.center`,
    defaultValue: 'Center'
  },
  addClassroom: {
    key: `${PATH}.add_classroom`,
    defaultValue: 'Add Classroom'
  },
  addCenter: {
    key: `${PATH}.add_center`,
    defaultValue: 'Add Center'
  },
  addNewNode: {
    key: `${PATH}.add_new_node`,
    defaultValue: 'Add New Node'
  },
  removeClassroom: {
    key: `${PATH}.remove_classroom`,
    defaultValue: 'Remove Classroom'
  },
  removeCenter: {
    key: `${PATH}.remove_center`,
    defaultValue: 'Remove Center'
  },
  nodeAdded: {
    key: `${PATH}.node_added`,
    defaultValue: '{{nodeName}} was successfully added'
  },
  nodeEdited: {
    key: `${PATH}.node_edit`,
    defaultValue: '{{nodeName}} was successfully edited'
  },
  nodeError: {
    key: `${PATH}.node_error`,
    defaultValue: '{{nodeName}} could not be added'
  },
  nodeEditError: {
    key: `${PATH}.node_edit_error`,
    defaultValue: '{{nodeName}} could not be edited'
  },
  nodeRemoved: {
    key: `${PATH}.node_removed`,
    defaultValue: '{{nodeName}} was removed from your account'
  },
  createNotAuthorized: {
    key: `${PATH}.create_not_authorized`,
    defaultValue:
      'You are not authorized to create a node under {{parentNodeName}}'
  },
  editNotAuthorized: {
    key: `${PATH}.edit_not_authorized`,
    defaultValue: 'You are not authorized to edit this node'
  },
  deleteNotAuthorized: {
    key: `${PATH}.delete_not_authorized`,
    defaultValue: 'You are not authorized to delete this node'
  }
};

export default messages;
